import { CwtApiConfig } from '@cawita/core-front/api';
import { CwtAuthConfig } from '@cawita/core-front/auth';
import { CwtCacheConfig } from '@cawita/core-front/api';
import { CwtAssetConfig } from '@cawita/core-front/asset';
import { environment } from '../../environments/environment';

export const PassportAssetConfig: CwtAssetConfig = {
    apiUrl: environment.assetUrl,
    protectedAssetPath: environment.protectedAssetUrl,
    publicAssetPath: environment.publicAssetPathUrl
}

export const PassportApiConfig: CwtApiConfig = {
    apiUrl: environment.apiUrl,
    apiVersion: 3
};

export const PassportCacheConfig: CwtCacheConfig = {
    useTTL: true,
    ttl: {
        // '*' : -1 // Change value to set ttl for ALL routes; -1 for "infinite" cache
    }
}

export const PassportAuthConfig: CwtAuthConfig = {
    api: {
        forgotPasswordEndpoint: 'user/reset/send-email',
        loginEndpoint: 'user/logged',
        logoutEndpoint: 'user/logged',
        registerEndpoint: 'user',
        resetPasswordEndpoint: 'user/reset',
        validateEmailEndpoint: 'user/validate/email'
    },
    store: {
        stateStorageKey: 'cwt-startapp-auth-store'
    },
    navigation: {
        defaultRoute: ['/passport'],
        loginRoute: ['/auth', 'login']
    },
};
